/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getDiscountDetail} from '../api'

 export const useQueryGetDiscountDetail = createReactQueryHook('getDiscountDetail', getDiscountDetail)
